import { render, staticRenderFns } from "./editTransactionComponent.vue?vue&type=template&id=20e4a1e7"
import script from "./editTransactionComponent.vue?vue&type=script&lang=js"
export * from "./editTransactionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports